import {ManyResponse} from '../../../responses';
import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FleetCostTable} from '../models';

@Injectable({
  providedIn: 'root'
})
export class TorchFleetPainCostService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  getFleetPainCosts(page: number = 0, limit: number = 50): Observable<FleetCostTable[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/pain-index/cost')
      .addQuery('limit', limit)
      .addQuery('page', page)
      .get;

    return this.httpClient.get<ManyResponse<FleetCostTable>>(endpointURL).pipe(
      map(response => response.data)
    );
  }
}
